import React from "react";
import classes from "./item.module.scss";
import PropTypes from "prop-types";

const Item = (props) => {
  const marks = [];
  for (let i = 0; i < props.danger; i++) {
    if (i < 3) {
      marks.push(
        <div
          className={classes.danger__mark}
          style={{ backgroundColor: "green" }}
        ></div>
      );
    } else if (3 <= i && i < 6) {
      marks.push(
        <div
          className={classes.danger__mark}
          style={{ backgroundColor: "orange" }}
        ></div>
      );
    } else if (6 <= i && i < 9) {
      marks.push(
        <div
          className={classes.danger__mark}
          style={{ backgroundColor: "red" }}
        ></div>
      );
    }
  }

  return (
    <li className={classes.item}>
      <b>{props.name}:</b>
      <div className={classes.lvl}>
        <div className={classes.content}>
          <p>
            Вміст:<span className={classes.data}> {props.content} </span>
            <span>{props.measurer}</span>
          </p>
          <span>{props.data}</span>
        </div>
        <div className={classes.content}>
          <p>
            Макс. концентрація:<span className={classes.data}> {props.max} </span>
            <span>{props.measurer}</span>
          </p>
        </div>
        <div className={classes.danger}>
          <span>Небезпека:</span>
          <div className={classes.danger__markList}>
            <div className={classes.danger__mark}></div>
            {marks}
          </div>
        </div>
      </div>
    </li>
  );
};

Item.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
};

export default Item;
